<template>
  <div v-if="activeNotifications[notificationKey]" class="tw-relative">
    <c-banner :type="bannerType">
      <q-badge
        v-if="activeNotifications[notificationKey].counter > 1"
        rounded
        :color="badgeColor"
        floating
        >{{ activeNotifications[notificationKey].counter }}</q-badge
      >
      {{ activeNotifications[notificationKey].message }}
    </c-banner>
  </div>
</template>

<script setup lang="ts">
import { useNotifyStore } from "store/modules/notifyStore.js";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import type { BannerType } from "shared/types";

const props = defineProps<{
  notificationKey: string;
}>();

const notifyStore = useNotifyStore();
const { activeNotifications } = storeToRefs(notifyStore);

const notificationType = computed(
  () => activeNotifications.value[props.notificationKey]?.type,
);

const bannerType = computed<BannerType>(() => {
  if (notificationType.value === "error") {
    return "negative";
  }
  if (notificationType.value === "success") {
    return "positive";
  }
  return notificationType.value ?? "info";
});

const badgeColor = computed<string>(() => {
  if (
    notificationType.value === "error" ||
    notificationType.value === "negative"
  ) {
    return "red";
  }
  if (
    notificationType.value === "positive" ||
    notificationType.value === "success"
  ) {
    return "green-10";
  }
  return "primary";
});
</script>
